<template>
  <v-container fluid grid-list-md style="padding: 30px;">
    <v-data-table :loading="tabela.carregamento" loading-text="Buscando recebidos..." :search="tabela.busca" :headers="tabela.cabecalho" :items="tabela.conteudo" sort-desc class="elevation-1" style="border-radius: 10px;" show-expand single-expand>
      <template v-slot:top>
        <v-toolbar flat color="white" style="border-radius: 10px;">
          <v-toolbar-title class="textoUser">RECEBIDOS</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field v-model="tabela.busca" append-icon="search" label="Pesquisa" single-line hide-details></v-text-field>
        </v-toolbar>
      </template>
      <template v-slot:no-data>
        <v-row>
          <v-col>
            <v-alert dark dense text outlined :value="true" color="warning" icon="info">Nenhum recebido encontrado</v-alert>
          </v-col>
        </v-row>
      </template>
      <template slot="no-results">
        <v-row>
          <v-col>
            <v-alert dark dense text outlined :value="true" color="warning" icon="info">Sua pesquisa por "{{tabela.busca}}" não trouxe resultados</v-alert>
          </v-col>
        </v-row>
      </template>
      <template v-slot:[`item.valor`]="{ item }">
        <td>R$ {{ item.valor }}</td>
      </template>
      <template v-slot:[`item.created`]="{ item }">
        <td>{{ transformaData(item.created, 'DD/MM/YYYY') }} às {{ transformaData(item.created, 'HH:mm:ss') }}</td>
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length">
          <div v-for="pedido in item.itensPedido" :key="pedido.produtoId">
            <v-row dense>
              <v-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2" style="text-align: center;" align-self="center">
                <v-avatar size="90px" tile class="ma-0">
                  <v-img style="border-radius: 15px;" :src="pedido.urlImagem"></v-img>
                </v-avatar>  
              </v-col> 
              <v-col cols="12" xs="12" sm="12" md="7" lg="7" xl="7" align-self="center">
                <v-card-title class="text-h6" v-text="pedido.descricao" style="font-weight: bold; color: #37474F;"></v-card-title>
                <v-card-subtitle v-text="pedido.detalhes"></v-card-subtitle>
              </v-col>
              <v-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3" align-self="center" style="text-align: center;">
                <h2 style="padding-top: 1px;padding-bottom: 1px;color: #00BFA5;font-weight: bold;">R$ {{pedido.preco}}</h2>
              </v-col>
            </v-row>
          </div>
        </td>
      </template>
    </v-data-table>
    <v-card-actions>
      <v-btn color="#5b3a4b" @click="carregaDados" dark>
        <v-icon left>refresh</v-icon>Atualizar
      </v-btn>
    </v-card-actions>
    <loading :active.sync="isLoading" :can-cancel="true" color="#7B1FA2" :is-full-page="fullPage"></loading>
    <Snackbar ref=chamaSnackbar />
  </v-container>
</template>

<script>
  // Import component
  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  import { baseApiUrl } from '@/global'
  import moment from 'moment'
  import Snackbar from '../componentes/snackbar.vue'
  import axios from 'axios'
  import { mapState } from 'vuex'
  export default {
    components: { Snackbar, Loading },
    data: () => ({
      fullPage: true,
      isLoading: false,
      faixas: [],
      tabela: {
        busca: '',
        cabecalho: [
          { text: 'Convidado', align: 'start', value: 'convidado.nome', },
          { text: 'Valor', value: 'valor' },
          { text: 'Data', value: 'created' },
          { text: 'Detalhes', value: 'data-table-expand' },
        ],
        carregamento: false,
        conteudo: [],
      },
    }),

    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,
      user: state => state.userObj,
      companyobj: state => state.companyObj,
    }),

    mounted() {
      this.carregaDados()
    },

    watch: {
      //
    },

    methods: {
      async carregaDados() {
        this.tabela.carregamento = true
        this.tabela.conteudo = []
        await axios.get(baseApiUrl + 'Pedidos?filter={"where":{"and":[{"empresaId":"'+this.companyobj.id+'"},{"statusPagamento":"PAGO"}]},"include":"convidado"}')
        .then(response => {
          if (response.data.length > 0) {
            this.tabela.conteudo = response.data
          }
          this.tabela.carregamento = false
        })
        .catch(() => {
          var vm = this
          vm.$refs.chamaSnackbar.snack("#EF5350", "Problema ao consultar recebidos", "DESCULPE")
        })
      },

      transformaData(data, formato) {
        let date = moment(data).format(formato);
        return date
      },
    },
  }
</script>

<style>
  .textoUser {
    font-weight: bold;
    color: #00253E;
    font-size: 17px;
  }

  .cssBotao {
    font-weight: bold;
    border-radius: 8px;
    width: 150px;
    font-size: 7px;
  }

  .theme--light.v-data-table thead tr th {
    color: white;
  }
</style>